// extracted by mini-css-extract-plugin
export default {"job-table":"JobApplication_job-table__kmx0g"};